import React from 'react';

const MAX_HOTEL_STARS = 5;

class HotelAutocompleteStars extends React.Component {
  render() {
    const count = Math.min(
      MAX_HOTEL_STARS,
      Math.max(0, Math.round(Number(this.props.value) || 0)),
    );
    if (count <= 0) return null;

    return (
      <span className="hotel-autocomplete-stars" aria-label={`${count} star hotel`}>
        {'★'.repeat(count)}
      </span>
    );
  }
}

export default HotelAutocompleteStars;
